<div [class.pt-4]="!props.readonly" [controlRef]="formControl" [fieldConfig]="this">
  <div>
    @for (set of sets; track set) {
      <p-card [header]="props.customSkillSet ? set.preferredLabel : ''">
        @if (!props.readonly && set.description) {
          <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
            {{ set.description }}
          </p-message>
        }

        <div [class]="field.fieldGroupClassName">
          @for (field of field.fieldGroup; track field) {
            @if (isInSet(field, set)) {
              @for (field of field.fieldGroup; track field) {
                @if (!field.hide) {
                  <formly-field [field]="field" />
                }
              }
            }
          }
        </div>
      </p-card>
    }
  </div>
</div>
